export const ANIMATION_TYPES = [{
  type: 'none',
  name: 'None',
  directions: null,
  defaultAnimation: null,
  buttonImg: '/images/animations/none.png'
}, {
  type: 'fade',
  name: 'Fade',
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'fade'
  },
  directions: null,
  buttonImg: '/images/animations/fade.png'
}, {
  type: 'slide',
  name: 'Slide',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    distance: 150,
    type: 'slide'
  },
  buttonImg: '/images/animations/slide.png'
}, {
  type: 'spin',
  name: 'Spin',
  directions: [
    { value: 'left', label: 'clockwise', icon: 'rotate-left' },
    { value: 'right', label: 'anti clockwise', icon: 'rotate-right' },
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    count: 1,
    type: 'spin'
  },
  buttonImg: '/images/animations/spin.png'
},{
  type: 'bounce',
  name: 'Bounce',
  // directions: [
  //   { value: 'left', label: 'from left', icon: 'left' },
  //   { value: 'right', label: 'from right', icon: 'right' },
  //   { value: 'top', label: 'from top', icon: 'top' },
  //   { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  // ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'bounce'
  },
  buttonImg: '/images/animations/bounce.png'
},
{
  type: 'arc',
  name: 'Arc',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'arc'
  },
  buttonImg: '/images/animations/arc.png'
},
{
  type: 'flip',
  name: 'Flip',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'flip'
  },
  buttonImg: '/images/animations/flip.png'
},
{
  type: 'expand',
  name: 'Expand',
  directions: null,
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'expand'
  },
  buttonImg: '/images/animations/expand.png'
},
{
  type: 'puffin',
  name: 'Puff-In',
  directions: null,
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'puffin'
  },
  buttonImg: '/images/animations/shrink.png'
},
// {
//   type: 'turn',
//   name: 'Turn-In',
//   directions: [
//     { value: 'left', label: 'from left', icon: 'left' },
//     { value: 'right', label: 'from right', icon: 'right' },
//   ],
//   defaultAnimation: {
//     duration: 1.2,
//     delay: 0,
//     direction: 'right',
//     type: 'turn'
//   },
//   buttonImg: '/images/animations/spin.png'
// },
{
  type: 'reveal',
  name: 'Reveal',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'reveal'
  },
  buttonImg: '/images/animations/reveal.png'
},
{
  type: 'parallax',
  name: 'Parallax',
  directions: [
    { value: 'vertical', label: 'vertical', icon: 'vertical' },
    { value: 'horizontal', label: 'horizontal', icon: 'horizontal' }
  ],
  defaultAnimation: {
    speed: 1,
    direction: 'vertical',
    angle: 0,
    type: 'parallax',
    reverse: false
  },
  buttonImg: '/images/animations/Parallax.png'
}
]

export const EXIT_ANIMATION_TYPES = [{
  type: 'none',
  name: 'None',
  directions: null,
  defaultAnimation: null,
  buttonImg: '/images/animations/none.png'
}, {
  type: 'fade',
  name: 'Fade',
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'fade'
  },
  directions: null,
  buttonImg: '/images/animations/fade.png'
}, {
  type: 'slide',
  name: 'Slide',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    distance: 150,
    type: 'slide'
  },
  buttonImg: '/images/animations/slide.png'
}, {
  type: 'spin',
  name: 'Spin',
  directions: [
    { value: 'left', label: 'clockwise', icon: 'rotate-left' },
    { value: 'right', label: 'anti clockwise', icon: 'rotate-right' },
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    count: 1,
    type: 'spin'
  },
  buttonImg: '/images/animations/spin.png'
},
{
  type: 'arc',
  name: 'Arc',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'arc'
  },
  buttonImg: '/images/animations/arc.png'
},
{
  type: 'flip',
  name: 'Flip',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'flip'
  },
  buttonImg: '/images/animations/flip.png'
},
{
  type: 'puffin',
  name: 'Puff-In',
  directions: null,
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'puffin'
  },
  buttonImg: '/images/animations/shrink.png'
},
{
  type: 'expand',
  name: 'Expand',
  directions: null,
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    type: 'expand'
  },
  buttonImg: '/images/animations/expand.png'
},
// {
//   type: 'turn',
//   name: 'Turn-In',
//   directions: [
//     { value: 'left', label: 'from left', icon: 'left' },
//     { value: 'right', label: 'from right', icon: 'right' },
//   ],
//   defaultAnimation: {
//     duration: 1.2,
//     delay: 0,
//     direction: 'right',
//     type: 'turn'
//   },
//   buttonImg: '/images/animations/spin.png'
// },
{
  type: 'reveal',
  name: 'Reveal',
  directions: [
    { value: 'left', label: 'from left', icon: 'left' },
    { value: 'right', label: 'from right', icon: 'right' },
    { value: 'top', label: 'from top', icon: 'top' },
    { value: 'bottom', label: 'from bottom', icon: 'bottom' }
  ],
  defaultAnimation: {
    duration: 1.2,
    delay: 0,
    direction: 'right',
    type: 'reveal'
  },
  buttonImg: '/images/animations/reveal.png'
},
{
  type: 'parallax',
  name: 'Parallax',
  directions: [
    { value: 'vertical', label: 'vertical', icon: 'vertical' },
    { value: 'horizontal', label: 'horizontal', icon: 'horizontal' }
  ],
  defaultAnimation: {
    speed: 1,
    direction: 'vertical',
    angle: 0,
    type: 'parallax',
    reverse: false
  },
  buttonImg: '/images/animations/Parallax.png'
}
]